import { useDisplayOptionContext } from "@/hooks/useDisplayOptionContext";
import { useUnitJourneyContext } from "@/hooks/useUnitJourneyContext";
import { useFacility } from "@/hooks/useFacility";
import { useUnitItemContext } from "@/hooks/useUnitItemContext";
import { translateWithMultipleSources } from "@/lib/translate";
import { FunnelType } from "@/lib/utils";
import { emitUnitEvent } from "@/utils/units/unitEvents";

export const useReservationAction = (unitId: number | string) => {
    const { reservationApp, language } = useDisplayOptionContext();
    const { setIsOpen, setUnitJourneyStep, setSelectedUnitId, setFunnelType } =
        useUnitJourneyContext();
    const { unitGroup, selectedPromo } = useUnitItemContext();
    const facilityId = unitGroup.representative_unit.facility_id;
    const { facility } = useFacility(facilityId);

    const redirectToExternalReservation = () => {
        if (reservationApp?.externalUrl && facility) {
            window.location.href = translateWithMultipleSources(
                reservationApp.externalUrl,
                {
                    unitGroup,
                    facility,
                    promo: { id: selectedPromo },
                },
                Number(unitId),
                Number(selectedPromo),
            );
        } else {
            console.error(
                "External reservation URL or facility information is missing.",
            );
        }
    };

    const openSamePageReservationFunnel = () => {
        emitUnitEvent(unitId, facilityId, selectedPromo, "reservation");
        setSelectedUnitId(unitId);
        setUnitJourneyStep("funnel");
        setFunnelType(FunnelType.RESERVE);
        setIsOpen(true);
    };

    const openReservationFunnel = () => {
        if (
            reservationApp?.location === "external" &&
            reservationApp.externalUrl
        ) {
            redirectToExternalReservation();
        } else {
            openSamePageReservationFunnel();
        }
    };

    const label = language?.action?.reserveButton || "Reserve";

    return { openReservationFunnel, label };
};
